module.exports = __webpack_public_path__ + "img/french_martini.87e39463.jpg";